import React, { useState, useContext } from 'react';

export const EntityContext = React.createContext({
  appendEntities: (_) => {
    void _;
  },
  findEntityByKey: (_) => {
    void _;
    return {};
  },
});

export const EntityProvider = ({ children }) => {
  const [entitiesMap, setEntitiesMap] = useState({});

  function appendEntities({ entityName, entityKey, entities }) {
    const entityMap = entitiesMap[entityName] || {};

    const draftEMap = entities.reduce(
      (acc, curr) => ({
        ...acc,
        [curr[entityKey]]: curr,
      }),
      {},
    );

    setEntitiesMap({
      ...entitiesMap,
      [entityName]: {
        ...entityMap,
        ...draftEMap,
      },
    });
  }

  function findEntityByKey({ entityName, key }) {
    const eMap = entitiesMap[entityName] || {};

    return eMap[key];
  }

  return (
    <EntityContext.Provider
      value={{
        appendEntities,
        findEntityByKey,
      }}
    >
      {children}
    </EntityContext.Provider>
  );
};

export const useEntityContext = function () {
  return useContext(EntityContext);
};
